<template>
  <div>
    <v-card class="rounded-card">
      <v-card-text class="text--primary">
        <v-row dense align="center">
          <v-col cols="12" sm="9" class="text-truncate">
            <px-situacao-requisicao-icon :situacao="requisicao.situacao"/>
            {{ requisicao.identificador }}
            <px-requisicao-urgencia :urgencia="requisicao.urgencia"/>
          </v-col>
          <v-col v-if="isAberta && hasModuleGerenciaOuRequisicao"
                 cols="12"
                 sm="3"
                 class="text-right">
            <v-btn v-if="hasModuleGerencia"
                   class="elevation-0 normal-btn-text rounded-tag-small" color="primary"
                   @click="criarCotacao">
              Criar cotação
            </v-btn>
            <px-requisicao-options
              :has-module-gerencia="hasModuleGerencia"
              :requisicao="requisicao"
              @update="onUpdate"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" class="caption">
            <v-icon>mdi-domain</v-icon>
            {{ requisicao.comprador.pessoa.nome }} ({{ requisicao.comprador.pessoa.cnpj | cnpj }})
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" class="caption">
            <v-icon>mdi-map-marker</v-icon>
            {{ requisicao.comprador.endereco | endereco }}
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Código</span>
            <div>
              {{ requisicao.id }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Projeto</span>
            <div>
              {{ projeto | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Centro de custo</span>
            <div>
              {{ centroCusto | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Data de Entrega</span>
            <div>
              {{ requisicao.dataEntrega | date | naoInformado }}
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Solicitante</span>
            <div>
              {{
                (requisicao.usuario ?
                  requisicao.usuario.nome : requisicao.nomeResponsavel) | naoInformado
              }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Observações internas</span>
            <div>
              <px-show-large-text :large-text="requisicao.observacaoInterna"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Observações externas</span>
            <div>
              <px-show-large-text :large-text="requisicao.observacaoExterna"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Finalidade da Compra</span>
            <div v-if="requisicao.finalidadeCompra">
              <px-finalidade-compra-value :finalidade-compra="requisicao.finalidadeCompra"/>
            </div>
            <div v-else>
              Não Informado
            </div>
          </v-col>
        </v-row>
        <v-row dense v-if="requisicao.codigoInterno">
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Código interno</span>
            <div>
              {{ requisicao.codigoInterno }}
            </div>
          </v-col>
        </v-row>
        <v-row dense v-if="requisicao.arquivos && requisicao.arquivos.length">
          <v-col cols="12">
            <span class="caption font-weight-bold">Anexos</span>
            <px-anexo-chip :files="requisicao.arquivos"
                           download-base-path="files/download-comprador"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <px-responsaveis
              v-if="hasModuleGerenciaOuGestorCompras"
              is-comprador
              :custom-path="customPath"
              :id="requisicao.id"
              :id-company="requisicao.comprador.id"
              :responsaveis="responsaveis"
              :roles="['ROLE_COMPRADOR']"
              :loading-responsaveis="loadingResponsaveis"
              modal-title="Alterar compradores responsáveis"
              listagem-title="Compradores responsáveis"
              label-autocomplete-responsavel="Comprador responsável"
              empty-responsaveis-text="Ainda não há nenhum comprador responsável"
              success-message-on-add="Comprador responsável adicionado!"
              success-message-on-remove="Comprador responsável removido!"
              @update-responsaveis="onUpdateResponsaveis"/>
          </v-col>
        </v-row>
        <px-requisicao-detalhes-comprador class="mt-3" :requisicao="requisicao"/>
        <px-requisicao-detalhes-produtos class="mt-3" :requisicao="requisicao"
                                         @update="onUpdate" />
        <px-requisicao-detalhes-fornecedores v-if="showFornecedores"
                                             class="mt-3" :requisicao="requisicao"/>
        <px-requisicao-detalhes-links :requisicao="requisicao" class="mt-3" />
        <px-requisicao-detalhes-mensagens-personalizadas
          v-if="checkMessages"
          class="mt-3"
          :requisicao="requisicao"/>
        <px-requisicao-detalhes-logs :id-requisicao="requisicao.id" v-if="hasIntegracaoAtiva"/>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import RequisicaoOptions from '@/modules/requisicao/RequisicaoOptions.vue';
import ObjectUtils from '@/utils/object-utils';
import { CUSTOM_PATH_RESPONSAVEL_REQUISICAO } from '@/utils/responsaveis-utils';
import ResponsaveisService from '@/api/responsaveis-service';
import { SituacaoRequisicao } from 'px-business-components';
import { mapGetters } from 'vuex';
import RequisicaoDetalhesComprador from './RequisicaoDetalhesComprador.vue';
import RequisicaoDetalhesProdutos from './RequisicaoDetalhesProdutos.vue';
import RequisicaoDetalhesFornecedores from './RequisicaoDetalhesFornecedores.vue';
import RequisicaoDetalhesMensagensPersonalizadas from './RequisicaoDetalhesMensagensPersonalizadas.vue';
import RequisicaoDetalhesLinks from './RequisicaoDetalhesLinks.vue';
import RequisicaoDetalhesLogs from './logs-requisicao/RequisicaoDetalhesLogs.vue';

export default {
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      responsaveis: [],
      loadingResponsaveis: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia', 'hasRoleGestorCompras', 'hasRoleRequisicao', 'hasIntegracaoAtiva']),
    centroCusto() {
      return this.requisicao.centroCusto
        ? ObjectUtils.descWithCodigoInterno(this.requisicao.centroCusto) : null;
    },
    projeto() {
      return this.requisicao.projeto
        ? ObjectUtils.descWithCodigoInterno(this.requisicao.projeto) : null;
    },
    showFornecedores() {
      return this.requisicao.fornecedores && this.requisicao.fornecedores.length;
    },
    isAberta() {
      const sistuacoesAbertas = [
        SituacaoRequisicao.keys.RECEBIDA.key,
        SituacaoRequisicao.keys.EM_COTACAO.key,
        SituacaoRequisicao.keys.EM_COMPRA.key,
      ];
      return sistuacoesAbertas.includes(this.requisicao.situacao);
    },
    checkMessages() {
      return this.requisicao.mensagensPersonalizadas
        && this.requisicao.mensagensPersonalizadas.length;
    },
    hasModuleGerenciaOuRequisicao() {
      return this.hasModuleGerencia || this.hasRoleRequisicao;
    },
    hasModuleGerenciaOuGestorCompras() {
      return this.hasModuleGerencia || this.hasRoleGestorCompras;
    },
    customPath() {
      return CUSTOM_PATH_RESPONSAVEL_REQUISICAO;
    },
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
    onUpdateResponsaveis() {
      this.getResponsaveisRequisicao();
    },
    getResponsaveisRequisicao() {
      this.loadingResponsaveis = true;
      ResponsaveisService.get(CUSTOM_PATH_RESPONSAVEL_REQUISICAO, this.requisicao.id)
        .then((response) => {
          this.responsaveis = response.data;
        })
        .finally(() => {
          this.loadingResponsaveis = false;
        });
    },
    criarCotacao() {
      this.$router.push({
        name: 'main.cotacoes.requisicao-cotacao',
        query: {
          idRequisicao: this.requisicao.id,
        },
        params: {
          isRascunho: false,
        },
      });
    },
  },
  created() {
    this.getResponsaveisRequisicao();
  },
  components: {
    pxRequisicaoDetalhesProdutos: RequisicaoDetalhesProdutos,
    pxRequisicaoDetalhesFornecedores: RequisicaoDetalhesFornecedores,
    pxRequisicaoOptions: RequisicaoOptions,
    pxRequisicaoDetalhesMensagensPersonalizadas: RequisicaoDetalhesMensagensPersonalizadas,
    pxRequisicaoDetalhesComprador: RequisicaoDetalhesComprador,
    pxRequisicaoDetalhesLinks: RequisicaoDetalhesLinks,
    pxRequisicaoDetalhesLogs: RequisicaoDetalhesLogs,
  },
};
</script>
